"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    kartleggVisningsdatastier: function() {
        return _vedleggUtil.kartleggVisningsdatastier;
    },
    finnAlle: function() {
        return finnAlle;
    },
    finnKorttypedefinisjon: function() {
        return finnKorttypedefinisjon;
    },
    finnBeregnedeFelter: function() {
        return finnBeregnedeFelter;
    },
    finnFelter: function() {
        return finnFelter;
    },
    harKortgruppekontroll: function() {
        return harKortgruppekontroll;
    },
    finnEgenskapEtterReferanse: function() {
        return finnEgenskapEtterReferanse;
    },
    finnDefinisjonGittKorttypereferanse: function() {
        return finnDefinisjonGittKorttypereferanse;
    },
    hentFellesDataAttributter: function() {
        return hentFellesDataAttributter;
    },
    erLikSomString: function() {
        return erLikSomString;
    },
    FELT_MED_EGENSKAPER: function() {
        return FELT_MED_EGENSKAPER;
    },
    BELOEPSFELT: function() {
        return BELOEPSFELT;
    },
    erFeltMedEgenskaper: function() {
        return erFeltMedEgenskaper;
    },
    getId: function() {
        return getId;
    },
    getFeltId: function() {
        return getFeltId;
    },
    removeLeadingZeros: function() {
        return removeLeadingZeros;
    }
});
var _flatMapDeep = /*#__PURE__*/ _interop_require_default(require("lodash/flatMapDeep"));
var _isEmpty = /*#__PURE__*/ _interop_require_default(require("lodash/isEmpty"));
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _vedleggUtil = require("./vedleggUtil");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var finnAlle = function(type) {
    var definisjon = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return (0, _flatMapDeep.default)(definisjon, function(barn) {
        return(// eslint-disable-next-line implicit-arrow-linebreak
        barn.type === type ? [
            barn
        ] : finnAlle(type, barn.barnliste));
    });
};
var finnKorttypedefinisjon = function(referanse, definisjon) {
    return finnAlle("korttype", definisjon).find(function(korttypedef) {
        return korttypedef.referanse === referanse;
    });
};
var finnBeregnedeFelter = function(korttypeRef, definisjon) {
    var kortdefinisjon = finnKorttypedefinisjon(korttypeRef, definisjon);
    return finnAlle("felt", kortdefinisjon.barnliste).filter(function(feltdef) {
        return feltdef.beregnetFelt;
    });
};
var finnFelter = function(korttypeRef, definisjon) {
    var kortdefinisjon = finnKorttypedefinisjon(korttypeRef, definisjon);
    return finnAlle("felt", kortdefinisjon.barnliste);
};
var harKortgruppekontroll = function(kontrollnavn, definisjon) {
    return finnAlle("kortgruppe", definisjon).some(function(kortgruppe) {
        return kortgruppe.kontroller && kortgruppe.kontroller.includes(kontrollnavn);
    });
};
var finnEgenskapEtterReferanse = function(referanse, egenskap, definisjon) {
    return (0, _get.default)(finnKorttypedefinisjon(referanse, definisjon), egenskap);
};
var finnDefinisjonGittKorttypereferanse = function(referanse, type, definisjon) {
    return finnAlle(type, definisjon).find(function(node) {
        if (node.referanse === referanse) {
            return node;
        }
        if (!(0, _isEmpty.default)(node.barnliste)) {
            return finnKorttypedefinisjon(referanse, node.barnliste);
        }
        return false;
    });
};
var FELLES_DATA_ATTRIBUTTER = [
    "id",
    "digest",
    "meta",
    "overfoertFraEtternavn",
    "overfoertFraFornavn",
    "overfoertFraMellomnavn",
    "overfoertFraFoedselsnummer",
    "overfoertFra"
];
var hentFellesDataAttributter = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return FELLES_DATA_ATTRIBUTTER.concat(options);
};
var erLikSomString = function(verdi1, verdi2) {
    return String(verdi1) === String(verdi2);
};
var FELT_MED_EGENSKAPER = "feltMedEgenskaper";
var BELOEPSFELT = "belopsfelt";
var erFeltMedEgenskaper = function(def) {
    return def.type === FELT_MED_EGENSKAPER;
};
var getId = function(def) {
    return def.id;
};
var getFeltId = function(feltDef) {
    return erFeltMedEgenskaper(feltDef) ? getId(feltDef[BELOEPSFELT]) : getId(feltDef);
};
var removeLeadingZeros = function(verdi, felt) {
    var _felt_opsjon;
    if ((_felt_opsjon = felt.opsjon) === null || _felt_opsjon === void 0 ? void 0 : _felt_opsjon.filtrerLedendeNull) {
        return verdi.replace(/^0+/, "");
    }
    return verdi;
};
